'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = exports.Thead = exports.Tbody = exports.Tr = exports.Th = exports.Td = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  padding: ', ' ', ' ', ' ', ';\n  height: ', ';\n  font-size: ', '\n  width: 15%;\n  font-family: ', ';\n  text-align: left;\n  white-space: nowrap;\n  ', ';\n'], ['\n  padding: ', ' ', ' ', ' ', ';\n  height: ', ';\n  font-size: ', '\n  width: 15%;\n  font-family: ', ';\n  text-align: left;\n  white-space: nowrap;\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: ', ' 0 ', ' ', ';\n  height: ', ';\n  font-size: ', '\n  text-align: left;\n  white-space: nowrap;\n  ', ';\n  font-weight: bold;\n'], ['\n  padding: ', ' 0 ', ' ', ';\n  height: ', ';\n  font-size: ', '\n  text-align: left;\n  white-space: nowrap;\n  ', ';\n  font-weight: bold;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  border-bottom: solid ', ' ', ';\n  ', ': last-of-type {\n    width: ', ';\n  }\n  ', ';\n'], ['\n  border-bottom: solid ', ' ', ';\n  ', ': last-of-type {\n    width: ', ';\n  }\n  ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n        &:hover > td {\n          cursor: pointer;\n          background: ', ';\n        }\n      '], ['\n        &:hover > td {\n          cursor: pointer;\n          background: ', ';\n        }\n      ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  color: ', ';\n'], ['\n  background-color: ', ';\n  color: ', ';\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  ', ' {\n    font-weight: bold;\n    height: ', '\n    color: ', '\n    background-color: white;\n  }\n\n'], ['\n  ', ' {\n    font-weight: bold;\n    height: ', '\n    color: ', '\n    background-color: white;\n  }\n\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  width: 100%;\n  font-family: ', ';\n  border-collapse: collapse;\n\n  ', ';\n'], ['\n  width: 100%;\n  font-family: ', ';\n  border-collapse: collapse;\n\n  ', ';\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n        ', ' {\n          border-bottom: ', ' solid ', ';\n          border-top: ', ' solid ', ';\n        }\n\n        ', ' {\n          border-bottom: ', ' solid ', ';\n          border-top: ', ' solid ', ';\n        }\n      '], ['\n        ', ' {\n          border-bottom: ', ' solid ', ';\n          border-top: ', ' solid ', ';\n        }\n\n        ', ' {\n          border-bottom: ', ' solid ', ';\n          border-top: ', ' solid ', ';\n        }\n      ']);

var _polished = require('polished');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var cellHeight = 30;

var Td = exports.Td = _styledComponents2.default.td(_templateObject, (0, _polished.rem)(5), (0, _polished.rem)(18), (0, _polished.rem)(5), (0, _polished.rem)(18), (0, _polished.rem)(cellHeight), function (_ref) {
  var theme = _ref.theme;
  return theme.table.fontSize || '14px';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily;
}, function (props) {
  if (props.center) {
    return 'text-align: center;';
  }

  if (props.right) {
    return 'text-align: right;';
  }

  return '';
});

var Th = exports.Th = _styledComponents2.default.th(_templateObject2, (0, _polished.rem)(5), (0, _polished.rem)(5), (0, _polished.rem)(18), (0, _polished.rem)(cellHeight), function (_ref3) {
  var theme = _ref3.theme;
  return theme.table.fontSize || '14px';
}, function (props) {
  if (props.center) {
    return 'text-align: center;';
  }

  if (props.right) {
    return 'text-align: right;';
  }

  return '';
});

var Tr = exports.Tr = _styledComponents2.default.tr(_templateObject3, (0, _polished.rem)(1), function (_ref4) {
  var theme = _ref4.theme;
  return theme.separatorColor;
}, Td, function (_ref5) {
  var equal = _ref5.equal;
  return equal ? 'auto' : '100%;';
}, function (props) {
  if (props.onClick) {
    return (0, _styledComponents.css)(_templateObject4, function (_ref6) {
      var theme = _ref6.theme;
      return theme.table.hover;
    });
  }

  return '';
});

var Tbody = exports.Tbody = _styledComponents2.default.tbody(_templateObject5, function (_ref7) {
  var theme = _ref7.theme;
  return theme.table.oddRowBg;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.table.evenRow;
});

var Thead = exports.Thead = _styledComponents2.default.thead(_templateObject6, Tr, (0, _polished.rem)(cellHeight + 20), function (_ref9) {
  var theme = _ref9.theme;
  return theme.color.base;
});

var Table = exports.Table = _styledComponents2.default.table(_templateObject7, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontFamily;
}, function (props) {
  if (props.mergeRow) {
    return (0, _styledComponents.css)(_templateObject8, Tr, (0, _polished.rem)(1), function (_ref11) {
      var theme = _ref11.theme;
      return theme.separatorColor;
    }, (0, _polished.rem)(1), function (_ref12) {
      var theme = _ref12.theme;
      return theme.separatorColor;
    }, Tr, (0, _polished.rem)(1), function (_ref13) {
      var theme = _ref13.theme;
      return theme.separatorColor;
    }, (0, _polished.rem)(1), function (_ref14) {
      var theme = _ref14.theme;
      return theme.separatorColor;
    });
  }
});

exports.default = {
  Table: Table,
  Tbody: Tbody,
  Thead: Thead,
  Tr: Tr,
  Th: Th,
  Td: Td
};